import React from 'react';
import { ToggleField } from '@bucketplace/commerce-admin-ui';

import { DurationInputField, FormContent, InspectorFormProvider } from '../../components';
import { ImageField } from '../../components/Input/ImageField';
import { DocumentInspectorProps } from '../../types';
import { convertDurationFormat } from '../../utils';
import { ImageProps } from './Image';

export function ImageInspector({
  value,
  onChange,
}: DocumentInspectorProps<ImageProps>) {
  return (
    <ImageInspectorContent
      value={value}
      onChange={onChange}
    />
  );
}

function ImageInspectorContent({
  value: inspectorValue,
  onChange,
}: DocumentInspectorProps<ImageProps>) {
  const convertedDuration = convertDurationFormat(inspectorValue.props.duration);
  const formValue = {
    ...inspectorValue,
    props: {
      ...inspectorValue.props,
      duration: convertedDuration,
    },
  };

  return (
    <InspectorFormProvider value={formValue} onChange={onChange}>
      <FormContent
        header="이미지"
        required
      >
        <ImageField
          name="src"
          label="이미지 업로드"
        />
      </FormContent>
      <FormContent header="노출시간 설정">
        <ToggleField
          name="duration"
        />
      </FormContent>
      { !!inspectorValue.props.duration && (
        <FormContent>
          <DurationInputField name="duration" />
        </FormContent>
      ) }
    </InspectorFormProvider>
  );
}
